import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger
} from '@/components/ui/alert-dialog';

interface Props {
  inboxName: string;
  /** The unit that becomes primary. */
  toUnitName: string;
  /** The current primary, or null when it is no longer in the account's unit list. */
  fromUnitName: string | null;
  onConfirm: () => void;
  /** Opens the confirmation when clicked. Leave out to drive it with `open` instead. */
  trigger?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * Asks before an inbox's primary unit changes. The primary takes every ticket whose customer
 * is not found in Shopify, so a mis-click would quietly reroute those tickets from then on.
 * Used by both ways of changing it: Save in the sharing dialog, and "Make primary" on a row.
 */
export function PrimaryChangeConfirm({
  inboxName,
  toUnitName,
  fromUnitName,
  onConfirm,
  trigger,
  open,
  onOpenChange
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Change the primary unit?</AlertDialogTitle>
          <AlertDialogDescription>
            Tickets on {inboxName} whose customer isn&apos;t found in Shopify will go to{' '}
            {toUnitName}
            {fromUnitName ? ` instead of ${fromUnitName}` : ''}. Existing conversations keep
            their unit.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Change primary</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
